import React from 'react';
import PropTypes from 'prop-types';
import { useEditor } from '@splashthat/splash-cms-engine';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';
import { useBootstrap } from 'utils/bootstrap/useBootstrap';
import { formatDateRange } from 'common/components/TouchpointEditor/utils/dateUtils';
import TextEditable from 'common/components/TouchpointEditor/TextEditable';
import { getAgendaCalendarProviders } from 'common/compounds/AgendaTouchpoint/components/nodes/AddToCalendarModal/CalendarProviders';
import {
    SessionSummaryContent,
    SessionsSummaryCalendar,
    SessionsCalendarHeadLineWrapper,
    SessionsCalendarLogoWrapper,
    SessionInformation,
    SessionContent,
} from './SessionsSummary.styles';
import CalendarAttachment from '../CalendarAttachment';

export const Sessions = ({
    sessionsDetails,
    sessionTitle,
    sessionInformation,
    setTitlePrefixText,
    addToCalendarContent,
    titlePrefixText,
    setAddToCalendarContent,
    addToCalendar,
    isCalendarVisible,
    isSessionWaitlisted,
    selected,
    hovered,
}) => {
    const bootstrapData = useBootstrap(['app.splashApiUrl']);
    const { theme, event, guest } = useTouchpointData();
    const apiUrl = bootstrapData['app.splashApiUrl'];
    const editor = useEditor((state) => ({
        editing: state.editing,
    }));
    const eventId = event.id;
    const { guestAccessHash } = guest;
    return (
        <SessionContent>
            {sessionsDetails.map((session, index) => (
                <SessionSummaryContent
                    $fontColor={theme.colors[sessionTitle?.styles?.fontColor]}
                    $fontFamily={theme.activeFonts[sessionTitle?.styles?.fontFamily]}
                    $fontSize={sessionTitle.styles.fontSize}
                    key={index}
                >
                    {(!session.registration_required || isSessionWaitlisted) && (
                        <TextEditable
                            setContent={setTitlePrefixText}
                            disabled={!editor.editing || (!selected && !hovered)}
                        >
                            {titlePrefixText}
                        </TextEditable>
                    )}
                    {session.name}

                    <SessionInformation
                        $fontColor={theme.colors[sessionInformation?.styles?.fontColor]}
                        $fontFamily={theme.activeFonts[sessionInformation?.styles?.fontFamily]}
                        $fontSize={sessionInformation?.styles?.fontSize}
                    >
                        <div> {formatDateRange(session.start, session.end)}</div>
                        {isCalendarVisible ? (
                            <SessionsSummaryCalendar>
                                <SessionsCalendarHeadLineWrapper>
                                    <TextEditable
                                        setContent={setAddToCalendarContent}
                                        disabled={!editor.editing || (!selected && !hovered)}
                                    >
                                        {addToCalendarContent}
                                    </TextEditable>
                                </SessionsCalendarHeadLineWrapper>

                                <SessionsCalendarLogoWrapper>
                                    <CalendarAttachment
                                        providers={getAgendaCalendarProviders({
                                            session,
                                            eventId,
                                            apiUrl,
                                            guestAccessHash,
                                        })}
                                        logoWidth="20"
                                        logoHeight="20"
                                        gap="8"
                                        providerLogoDisplay="none"
                                        styles={addToCalendar.styles}
                                        meta={addToCalendar.meta}
                                        descendants={addToCalendar.descendants}
                                    />
                                </SessionsCalendarLogoWrapper>
                            </SessionsSummaryCalendar>
                        ) : null}
                    </SessionInformation>
                </SessionSummaryContent>
            ))}
        </SessionContent>
    );
};

Sessions.propTypes = {
    hovered: PropTypes.bool.isRequired,
    selected: PropTypes.bool.isRequired,
    sessionsDetails: PropTypes.array,
    sessionTitle: PropTypes.object,
    sessionInformation: PropTypes.object,
    setTitlePrefixText: PropTypes.func,
    addToCalendarContent: PropTypes.string,
    titlePrefixText: PropTypes.string,
    setAddToCalendarContent: PropTypes.func,
    addToCalendar: PropTypes.object,
    isCalendarVisible: PropTypes.bool,
    isSessionWaitlisted: PropTypes.bool,
};
